import { FC, HtmlHTMLAttributes } from "react";
import { ChevronRight } from "components/Icons/ChevronRight";
import { GeneralRoutingLinkButton } from "components/Molecules/GeneralRoutingLinkButton";
import { ComponentAtomsLink } from "types/graphql/generated";

interface FeaturedLinksListProps extends HtmlHTMLAttributes<HTMLDivElement> {
  links?: ComponentAtomsLink[];
}

const FeaturedLinksList: FC<FeaturedLinksListProps> = ({ links = [] }) => {
  const buttonClasses =
    "justify-start gap-1 border-0 bg-transparent p-0 text-base font-semibold text-fog-80 hover:bg-transparent hover:opacity-70 active:opacity-70 focus:opacity-70  active:bg-transparent";

  const iconClasses =
    "-translate-x-1 opacity-0 transition duration-300 ease-in-out group-hover:translate-x-0 group-focus:translate-x-0 group-hover:opacity-100 group-focus:opacity-100 h-3 w-3 [&>svg]:h-3 [&>svg]:w-3";

  return (
    <ul className="flex flex-col gap-4">
      {links.map(({ url, label, id }) => (
        <li key={id}>
          <GeneralRoutingLinkButton
            className={buttonClasses}
            href={url}
            rightIcon={<ChevronRight height={12} width={12} />}
            iconCustomClasses={iconClasses}
          >
            {label}
          </GeneralRoutingLinkButton>
        </li>
      ))}
    </ul>
  );
};

export { FeaturedLinksList };
